import React from 'react';

export default function Email() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 512 384">
      <path id="envelope-regular" d="M464,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V112A48,48,0,0,0,464,64Zm0,48v40.8c-22.422,18.259-58.168,46.651-134.587,106.49-16.841,13.247-50.2,45.072-73.413,44.7-23.208.375-56.579-31.459-73.413-44.7C106.18,199.465,70.425,171.067,48,152.8V112ZM48,400V214.4c22.914,18.251,55.409,43.862,104.938,82.646C174.795,314.249,213.072,352.23,256,352c42.717.231,80.509-37.2,103.053-54.947,49.528-38.783,82.032-64.4,104.947-82.653V400Z" transform="translate(0 -64)" />
    </svg>
  );
}
